<template>
  <header
    v-if="!Edicao"
    class="sticky top-0 z-50 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 shadow-sm"
  >
    <div class="flex items-center justify-between px-6 py-4">
      <!-- Logo -->
      <CompanyLogo :nome-empresa="nomeEmpresa" :is-dark="isDark" />

      <!-- Navigation buttons -->
      <div class="hidden lg:flex items-center gap-3">
        <!-- Dark mode toggle -->
        <button
          @click="toggleTheme"
          class="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
          aria-label="Toggle dark mode"
        >
          <svg
            v-if="!isDark"
            class="w-5 h-5 text-yellow-500"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
            />
          </svg>
          <svg
            v-else
            class="w-5 h-5 text-slate-300"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
            />
          </svg>
        </button>

        <!-- Alterar senha -->
        <button
          v-if="configuracaoToken != 'S'"
          @click="alterarSenha()"
          class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
        >
          Alterar senha
        </button>

        <!-- Logoff -->
        <button
          @click="logoff"
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 dark:bg-blue-600 rounded-lg hover:bg-blue-700 dark:hover:bg-blue-700 transition-colors"
        >
          Logoff
        </button>
      </div>
    </div>
  </header>

  <!-- Mobile Toggle Button -->
  <div
    v-if="!Edicao"
    class="lg:hidden sticky top-0 z-30 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 px-4 py-3"
  >
    <div class="flex items-center justify-between">
      <button
        @click="menuAberto = !menuAberto"
        class="p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>
      <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ nomeMenu }}
      </span>

      <!-- Dark mode toggle mobile -->
      <button
        @click="toggleTheme"
        class="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
      >
        <svg
          v-if="!isDark"
          class="w-5 h-5 text-yellow-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
          />
        </svg>
        <svg
          v-else
          class="w-5 h-5 text-slate-300"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
          />
        </svg>
      </button>
    </div>
  </div>

  <!-- Overlay Mobile -->
  <Transition name="fade">
    <div
      v-if="menuAberto && !Edicao"
      @click="menuAberto = false"
      class="fixed inset-0 bg-black/50 dark:bg-black/70 z-40 lg:hidden"
    ></div>
  </Transition>

  <!-- Sidebar Mobile -->
  <Transition name="slide">
    <div
      v-if="menuAberto && !Edicao"
      class="fixed top-0 left-0 h-full w-80 bg-white dark:bg-slate-900 shadow-2xl z-50 overflow-y-auto lg:hidden"
    >
      <!-- Header -->
      <div
        class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-slate-700"
      >
        <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
          Cadastro Pessoa Física
        </h3>
        <button
          @click="menuAberto = false"
          class="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Menu items -->
      <nav class="p-4">
        <ul class="space-y-2">
          <li v-for="(item, index) in menuItems" :key="index">
            <a
              href="javascript:;"
              @click="selectTab(index)"
              :class="[
                'flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                tab === index
                  ? 'bg-primary text-white dark:bg-blue-600'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800',
                tab > index && 'text-green-600 dark:text-green-400',
              ]"
            >
              <!-- Checkmark se preenchido -->
              <svg
                v-if="tab > index"
                class="w-5 h-5 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                />
              </svg>
              <span>{{ item }}</span>
            </a>
          </li>

          <!-- Logout -->
          <li class="pt-4 border-t border-gray-200 dark:border-slate-700">
            <a
              href="javascript:;"
              @click="logoff"
              class="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              Sair
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </Transition>

  <!-- Container Principal -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
    <!-- Título -->
    <div v-if="!Edicao" class="mb-6">
      <h2 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
        Cadastro
      </h2>
    </div>

    <!-- Navegação Wizard Desktop - Stepper Moderno -->
    <div v-if="!Edicao" class="hidden lg:block mb-8">
      <div class="relative">
        <div class="flex items-start justify-between">
          <div
            v-for="(item, index) in menuItems"
            :key="index"
            class="flex flex-col items-center flex-1 relative"
            :class="{
              'cursor-pointer': index <= maxTab,
              'cursor-not-allowed': index > maxTab,
            }"
            @click="index <= maxTab && selectTab(index)"
          >
            <!-- Linha conectora -->
            <div
              v-if="index < menuItems.length - 1"
              class="absolute top-5 left-1/2 w-full h-0.5 -z-10"
              :class="[
                index < tab
                  ? 'bg-green-500 dark:bg-green-400'
                  : 'bg-gray-200 dark:bg-slate-700',
              ]"
            ></div>

            <!-- Círculo com número/check -->
            <div
              class="flex items-center justify-center w-10 h-10 rounded-full border-2 mb-2 transition-all duration-200"
              :class="[
                tab === index
                  ? 'bg-primary border-primary text-white dark:bg-blue-600 dark:border-blue-600 scale-110 shadow-lg'
                  : index < tab
                  ? 'bg-green-500 border-green-500 text-white dark:bg-green-400 dark:border-green-400'
                  : index <= maxTab
                  ? 'bg-white border-gray-300 text-gray-700 dark:bg-slate-800 dark:border-slate-600 dark:text-gray-300 hover:border-primary dark:hover:border-blue-500'
                  : 'bg-gray-100 border-gray-200 text-gray-400 dark:bg-slate-900 dark:border-slate-800 dark:text-slate-600',
              ]"
            >
              <!-- Checkmark para etapas concluídas -->
              <svg
                v-if="index < tab"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <!-- Número para etapas atuais/futuras -->
              <span v-else class="text-sm font-semibold">{{ index + 1 }}</span>
            </div>

            <!-- Label -->
            <span
              class="text-xs text-center max-w-[120px] leading-tight transition-colors"
              :class="[
                tab === index
                  ? 'text-primary font-semibold dark:text-blue-400'
                  : index < tab
                  ? 'text-green-600 font-medium dark:text-green-400'
                  : index <= maxTab
                  ? 'text-gray-600 dark:text-gray-400'
                  : 'text-gray-400 dark:text-slate-600',
              ]"
            >
              {{ item }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Wrapper do Conteúdo com Card -->
    <div
      class="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 overflow-hidden"
    >
      <div class="p-4 sm:p-6">
        <div v-if="tab == 0">
          <Informacoes
            v-if="informacoesBasicas"
            ref="form_0"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesBasicas" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 1">
          <Representantes :Edicao="Edicao" ref="form_1" />
        </div>
        <div v-if="tab == 2">
          <DadosFinanceiros
            v-if="informacoesFinanceiras"
            ref="form_2"
            :informacoesFinanceiras="informacoesFinanceiras"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesFinanceiras" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 3">
          <DadosBancarios
            v-if="informacoesBancarias"
            ref="form_3"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesBancarias" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 4">
          <Endereco
            v-if="informacoesBasicas"
            ref="form_4"
            :informacoesBasicas="informacoesBasicas"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesBasicas" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 5">
          <UploadDocumentos :Edicao="Edicao" ref="form_5" />
        </div>
        <div v-if="tab == 6">
          <Declaracoes
            v-if="informacoesDeclaracoes"
            ref="form_6"
            :informacoesDeclaracoes="informacoesDeclaracoes"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesDeclaracoes" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 7">
          <Produtos
            :Edicao="Edicao"
            :nomeAbaProdutos="nomeAbaProdutos"
            ref="form_7"
          />
        </div>
      </div>

      <!-- Footer Fixo -->
      <div
        class="sticky bottom-0 lg:static bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-slate-700 px-4 sm:px-6 py-4"
      >
        <div class="flex flex-col sm:flex-row gap-3 sm:justify-between">
          <button
            @click="validarFormularioAtual"
            class="order-2 sm:order-1 px-6 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
          >
            {{ Edicao ? "Salvar" : "Salvar e continuar depois" }}
          </button>

          <button
            v-if="!Edicao"
            @click="proximaEtapa"
            class="order-1 sm:order-2 px-6 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors shadow-sm"
          >
            {{ tab == 7 ? "Concluir" : "Avançar" }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <ModalAlterarSenha />
  <ModalAlerta
    :mostrar="modalAlerta.mostrar"
    :tipo="modalAlerta.tipo"
    :titulo="modalAlerta.titulo"
    :mensagem="modalAlerta.mensagem"
    @fechar="fecharModalAlerta"
  />
</template>

<script>
import CompanyLogo from "@/components/CompanyLogo.vue";
import { mapGetters, mapActions } from "vuex";
import { useTheme } from "@/composables/useTheme";
import Informacoes from "./Informacoes.vue";
import DadosFinanceiros from "./DadosFinanceiros.vue";
import DadosBancarios from "./DadosBancarios.vue";
import Endereco from "./Endereco.vue";
import Representantes from "./Representantes.vue";
import UploadDocumentos from "./UploadDocumentos.vue";
import Declaracoes from "./Declaracoes.vue";
import Produtos from "./Produtos.vue";
import api from "@/api/axios";
import { parseCurrencyToNumber } from "@/utils/formUtils";

import navigationTracker from "@/services/modules/userNavigationTracker";
import ModalAlterarSenha from "../AlterarSenha/ModalAlterarSenha.vue";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";

import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

export default {
  components: {
    CompanyLogo,
    Informacoes,
    DadosFinanceiros,
    DadosBancarios,
    Endereco,
    UploadDocumentos,
    Declaracoes,
    Produtos,
    Representantes,
    ModalAlterarSenha,
    ModalAlerta,
  },
  props: ["Edicao", "BloquearSalvarIsolado"],
  name: "CadastroPF_Passo_1",

  setup() {
    const { isDark, toggleTheme } = useTheme();
    return { isDark, toggleTheme };
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
      etapaCadastro: "GET_ETAPA_CADASTRO",
      infoBasicas: "GET_PF_INFO_BASICAS",
      infoFinanceiras: "GET_PF_INFO_FINANCEIRAS",
      infoBancarios: "GET_PF_INFO_BANCARIOS",
      infoDeclaracoes: "GET_PF_INFO_DECLARACOES",
      salvarInformacoesPF: "GET_PF_SALVAR_INFO",
      salvarObjInfoBasicas: "GET_PF_SALVAR_INFO_BASICAS",
      salvarObjInfoFinanceira: "GET_PF_SALVAR_INFO_FINANCEIRAS",
      salvarObjInfoBancarias: "GET_PF_SALVAR_INFO_BANCARIAS",
      salvarObjInfoEndereco: "GET_PF_SALVAR_INFO_ENDERECO",
      ObjSalvarQuestionario: "GET_SALVAR_QUESTIONARIO",
      salvarObjInfoDeclaracoes: "GET_PF_SALVAR_INFO_DECLARACOES",
      salvarObjInfoContasAdicionais: "GET_PF_SALVAR_INFO_CONTAS_ADICIONAIS",
      ObjSalvarInformacoesUploadArquivos: "GET_SALVAR_INFO_UPLOAD",
      salvarObjInfoBasicosRepresentante:
        "GET_PF_SALVAR_INFO_BASICAS_REPRESENTANTES",
      salvarObjConcluir: "GET_FICHA_CONCLUIR",
      salvarObjDispensaQuestionario: "GET_PF_PJ_SALVAR_INFO_DISPENSA",
      desabilitarNotificacao: "GET_SALVAR_INFO_DES_NOTIFICACAO",
      etapasConcluidas: "GET_ETAPA_CONCLUIDA",
      getConfiguracoes: "GET_CONFIGURACOES",
      enviarCadastro: "GET_ENVIAR_CADASTRO",
    }),
    salvouTodasAbas() {
      const { gravarDados } = this;
      return Object.values(gravarDados).every((value) => value === 1);
    },
    menuItems() {
      return [
        "Informações",
        "Procuradores",
        "Dados Financeiros",
        "Dados Bancários",
        "Endereços",
        "Upload de Documentos",
        "Declarações",
        this.nomeAbaProdutos,
      ];
    },
    nomeMenu() {
      const menus = this.menuItems;
      return menus[this.tab] || "Menu Desconhecido";
    },
  },
  data() {
    return {
      menuAberto: false,
      maxTab: 0,
      configuracaoToken: "N",
      nomeAbaProdutos: "Produtos",
      solicitouProximaEtapa: false,
      gravarDados: {
        salvarInformacoesPF: 0,
        salvarInformacoesFinanceiras: 0,
        salvarInformacoesBancarias: 0,
        salvarInformacoesDeclaracoes: 0,
        salvarInformacoesUpload: 0,
        salvarInformacoesDispensaQuestionario: 0,
        salvarQuestionario: 0,
      },
      nomeEmpresa: "",
      tab: 0,
      informacoesBasicas: null,
      informacoesFinanceiras: this.infoFinanceiras,
      informacoesBancarias: this.infoBancarios,
      informacoesDeclaracoes: this.infoDeclaracoes,
      modalAlerta: {
        mostrar: false,
        tipo: "success",
        titulo: "",
        mensagem: "",
        aoFechar: null,
      },
    };
  },
  created() {
    this.ObterDados();
    this.$store.commit("SET_FICHA_CONCLUIR", false);
  },
  async mounted() {
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    this.$store.commit("SET_PF_SALVAR_INFO", false);
    if (!this.Edicao) {
      this.$store.commit("SET_ETAPA_CADASTRO", 0);
    } else {
      this.tab = this.etapaCadastro;
    }
    await this.fetchConfiguracao([
      "Modo de autenticação",
      "OnBoarding - Nomeclatura da aba de produto",
    ]);
    this.configuracaoToken =
      this.getConfiguracoes("Modo de autenticação")?.Valor != "2" ? "N" : "S";

    if (this.infoBasicas != null) {
      this.informacoesBasicas = this.infoBasicas;
      this.informacoesBasicas.Nome = this.user.NomeRazaoSocial;
    }

    this.nomeAbaProdutos =
      this.getConfiguracoes("OnBoarding - Nomeclatura da aba de produto")
        ?.Valor ?? "Produtos";

    if (this.infoFinanceiras != null)
      this.informacoesFinanceiras = this.infoFinanceiras;

    if (this.infoBancarios != null)
      this.informacoesBancarias = this.infoBancarios;

    if (this.infoDeclaracoes != null)
      this.informacoesDeclaracoes = this.infoDeclaracoes;
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    houveAlteracaoRepresentantesCriticos() {
      const atual = this.salvarObjInfoBasicas || {};
      const original = this._repSnap || {};

      const toIntOrNull = (v) =>
        v === null || v === undefined || v === "" ? null : Number(v);

      const situacaoAtual = toIntOrNull(atual.SituacaoLegal);
      const situacaoOriginal = toIntOrNull(original.SituacaoLegal);

      const situacoesComRepresentante = [2, 4, 5];

      const atualTemRepresentante =
        situacoesComRepresentante.includes(situacaoAtual);
      const originalTemRepresentante =
        situacoesComRepresentante.includes(situacaoOriginal);

      // 1) Entrou ou saiu do grupo 2/4/5 → alteração crítica
      if (atualTemRepresentante !== originalTemRepresentante) {
        return true;
      }

      // 2) Continua em 2/4/5 → comparar dados do representante
      if (atualTemRepresentante) {
        const norm = (v) => (v || "").toString().trim();
        const normLower = (v) => norm(v).toLowerCase();

        const mudouRepresentante =
          norm(original.NomeRepresentante) !== norm(atual.NomeRepresentante) ||
          norm(original.CpfRepresentante) !== norm(atual.CpfRepresentante) ||
          normLower(original.EmailRepresentante) !==
            normLower(atual.EmailRepresentante);

        if (mudouRepresentante) {
          return true;
        }
      }

      return false;
    },
    async validarFormularioAtual() {
      const refName = `form_${this.tab}`;
      const componente = this.$refs[refName];
      if (this.Edicao && componente?.validarFormulario && refName != "form_1") {
        if (componente.validarFormulario(true)) {
          if (componente?.salvarInformacoes) {
            const sucesso = await componente.salvarInformacoes();
            if (sucesso !== false && refName === "form_5") {
              this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
              this.$emit("update:Edicao", false);
            }
          } else if (this.BloquearSalvarIsolado) {
            this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
          }
        }
      } else {
        if (componente?.salvarInformacoes) {
          componente.salvarInformacoes();
        } else if (this.BloquearSalvarIsolado) {
          this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
        } else {
          this.$swal({
            icon: "success",
            title: "Alterações realizadas com sucesso!",
            text: "Dados informados foram salvos com sucesso.",
          });
        }
      }
    },
    proximaEtapa() {
      const refName = `form_${this.tab}`;
      const componente = this.$refs[refName];

      if (componente?.proximaEtapa) {
        componente.proximaEtapa();
      }
    },
    alterarSenha() {
      this.$store.commit("SET_ABRIR_ALTERAR_SENHA", true);
    },
    fecharModalAlerta() {
      if (
        this.modalAlerta.aoFechar &&
        typeof this.modalAlerta.aoFechar === "function"
      ) {
        this.modalAlerta.aoFechar();
      }
      this.modalAlerta = {
        mostrar: false,
        tipo: "success",
        titulo: "",
        mensagem: "",
        aoFechar: null,
      };
    },
    formatarValorFinanceiro(valor) {
      return parseCurrencyToNumber(valor) ?? 0;
    },
    async ObterDados() {
      await this.$store.commit("SET_PF_SALVAR_INFO", false);
      await this.$store.commit("SET_PF_SALVAR_INFO_BANCARIAS", null);
      await this.$store.commit("SET_PF_SALVAR_INFO_CONTAS_ADICIONAIS", null);
      await this.$store.dispatch("FETCH_PF_INFO_BASICAS");
      await this.$store.dispatch("FETCH_PF_INFO_BASICAS_REPRESENTANTES");
      await this.$store.dispatch("FETCH_PF_INFO_FINANCEIRAS");
      await this.$store.dispatch("FETCH_PF_INFO_BANCARIOS");
      await this.$store.dispatch("FETCH_PF_INFO_DECLARACOES");
      await this.$store.dispatch("FETCH_CONSULTA_BANCOS");
      await this.$store.dispatch("FETCH_CONSULTA_PAISES");
      await this.$store.dispatch("FETCH_CONSULTA_NACIONALIDADES");
      await this.$store.dispatch("FETCH_CONSULTA_OCUPACAO_PROFISSIONAL");
      await this.$store.dispatch("FETCH_CONSULTA_FORMACAO_PROFISSIONAL");
      await this.$store.dispatch("FETCH_QUESTIONARIO_BUSCAR_QUESTOES");
      await this.$store.dispatch("FETCH_CONSULTA_DISCLAIMER");
      await this.$store.dispatch("FETCH_CONSULTA_ORGAO_EMISSOR");
    },
    async salvarConcluir() {
      if (this.salvarInformacoesPF == true && this.salvarObjConcluir == true) {
        this.$store.commit("SET_PF_SALVAR_INFO", false);
        this.$store.commit("SET_FICHA_CONCLUIR", false);
        this.$store.commit("SET_ENVIAR_CADASTRO", false);

        const data = {
          RenovacaoCadastral: this.BloquearSalvarIsolado,
        };

        await api
          .post("/PessoaFisica/ConcluirCadastro", data)
          .then(async (retorno) => {
            if (retorno.status == 200) {
              // Notificar conclusao via SignalR
              await navigationTracker.trackCadastroCompleted({
                renovacao: this.BloquearSalvarIsolado,
                completedSteps: this.etapasConcluidas || [],
              });

              if (this.user.StatusCadastro > 1) {
                this.modalAlerta = {
                  mostrar: true,
                  tipo: "warning",
                  titulo: "Cadastro atualizado",
                  mensagem:
                    "As informações serão revisadas pela equipe responsável e você poderá acompanhar essa revisão pelo status.",
                };

                this.user.StatusCadastro = 4;
                this.$store.commit("auth/SET_USER", this.user);
              } else {
                this.modalAlerta = {
                  mostrar: true,
                  tipo: "success",
                  titulo: "Cadastro enviado!",
                  mensagem: "Seu cadastro está em análise.",
                  aoFechar: () => this.logoff(),
                };
              }
            }
          })
          .catch((error) => {
            this.$store.commit("SET_PF_SALVAR_INFO", false);
            this.modalAlerta = {
              mostrar: true,
              tipo: "error",
              titulo: "Dados informados inválidos na aba Declarações",
              mensagem: `${error.response.data.data[0]}`,
            };
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Declarações",
              text: `${error.response.data.data[0]}`,
            });
          });
      } else {
        this.$store.commit("SET_PF_SALVAR_INFO", false);
        if (this.desabilitarNotificacao == true) {
          this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", false);
        } else if (!this.Edicao) {
          this.$swal({
            icon: "success",
            title: "Alterações realizadas com sucesso!",
            text: "Dados informados foram salvos com sucesso.",
          });
        }
        this.ObterDados();
      }
    },
    async salvarInformacoesDeclaracoes() {
      if (this.salvarInformacoesPF) {
        if (this.salvarObjInfoDeclaracoes == null) {
          this.gravarDados.salvarInformacoesDeclaracoes = 1;
          return;
        } else {
          await api
            .post("/PessoaFisica/declaracoes", this.salvarObjInfoDeclaracoes)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.commit("SET_PF_SALVAR_INFO_DECLARACOES", null);
                this.gravarDados.salvarInformacoesDeclaracoes = 1;
                return;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarInformacoesDeclaracoes = 2;
              this.$store.commit("SET_PF_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos na aba Declarações",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarInformacoesDispensaQuestionario() {
      if (this.salvarInformacoesPF) {
        if (this.salvarObjDispensaQuestionario == null) {
          this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
          return;
        } else {
          await api
            .post(
              "/suitability/dispensa-questionario",
              this.salvarObjDispensaQuestionario,
            )
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.commit("SET_PF_PJ_SALVAR_INFO_DISPENSA", null);
                this.$store.dispatch("FETCH_PERFIL_CLIENTE");
                this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
                return;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarInformacoesDispensaQuestionario = 2;
              this.$store.commit("SET_PF_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title:
                  "Dados informados inválidos na aba Produtos, sessão Dispensa de Questionário.",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarInformacoesUpload() {
      if (!this.salvarInformacoesPF) {
        return;
      }
      if (this.ObjSalvarInformacoesUploadArquivos == null) {
        this.$store.dispatch(
          "FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO",
        );
        this.gravarDados.salvarInformacoesUpload = 1;
        return;
      }

      if (this.ObjSalvarInformacoesUploadArquivos == null) {
        this.gravarDados.salvarInformacoesUpload = 1;
        return;
      } else {
        const data = {
          documentos: this.ObjSalvarInformacoesUploadArquivos,
        };
        await api
          .post("/cliente/documentos", data)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit("SET_SALVAR_INFO_UPLOAD", null);
              this.gravarDados.salvarInformacoesUpload = 1;
              this.$store.dispatch(
                "FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO",
              );
              return;
            }
          })
          .catch((error) => {
            this.gravarDados.salvarInformacoesUpload = 2;
            this.$store.commit("SET_PF_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Falha ao realizar upload de documentos",
              text: `${error.response.data.data[0]}`,
            });
          })
          .finally(() => {
            this.$store.dispatch(
              "FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO",
            );
          });
      }
    },
    async salvarQuestionarioAsync() {
      if (this.salvarInformacoesPF) {
        if (this.ObjSalvarQuestionario == null) {
          this.gravarDados.salvarQuestionario = 1;
          return;
        } else {
          await api
            .post("/suitability", this.ObjSalvarQuestionario)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.commit("SET_SALVAR_QUESTIONARIO", null);
                this.gravarDados.salvarQuestionario = 1;
                this.$store.commit("SET_MODAL_QUESTIONARIO", false);

                if (!this.BloquearSalvarIsolado && !this.Edicao) {
                  this.$alert({
                    icon: "success",
                    title: "Salvo com sucesso!",
                    text: "Seus dados foram salvos.",
                  });
                }

                this.$store.dispatch("FETCH_PERFIL_CLIENTE");

                if (this.Edicao) {
                  if (
                    this.user.StatusCadastro == 3 &&
                    !this.user.PermiteLoginEmRevisao
                  ) {
                    this.logoff();
                  } else {
                    this.user.StatusCadastro = 4;
                  }
                }
              } else {
                this.gravarDados.salvarQuestionario = 2;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarQuestionario = 2;
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos.",
                text: `${error.response.descricao}`,
              });
            });
        }
      }
    },
    async salvarInformacoesBancarias() {
      if (this.salvarInformacoesPF) {
        // Verificar se temos dados bancários para salvar
        if (
          this.salvarObjInfoBancarias === null ||
          (Array.isArray(this.salvarObjInfoBancarias) &&
            this.salvarObjInfoBancarias.length === 0)
        ) {
          this.gravarDados.salvarInformacoesBancarias = 1;
          return;
        }

        try {
          // Fazer uma única chamada para a API com todas as contas bancárias
          const retorno = await api.post(
            "/PessoaFisica/dadosBancarios",
            this.salvarObjInfoBancarias,
          );

          if (retorno.status === 200) {
            this.$store.commit("SET_PF_SALVAR_INFO_BANCARIAS", null);
            this.gravarDados.salvarInformacoesBancarias = 1;
          } else {
            throw new Error("Falha ao salvar dados bancários");
          }
        } catch (error) {
          this.gravarDados.salvarInformacoesBancarias = 2;
          const errorMessage =
            error.response?.data?.data?.[0] ||
            "Erro ao salvar os dados bancários.";
          this.$swal({
            icon: "error",
            title: "Dados informados inválidos na aba Dados Bancários",
            text: errorMessage,
          });
          this.$store.commit("SET_PF_SALVAR_INFO", false);
        }
      }
    },
    async salvarInformacoesFinanceiras() {
      if (this.salvarInformacoesPF) {
        if (this.salvarObjInfoFinanceira == null) {
          this.gravarDados.salvarInformacoesFinanceiras = 1;
          return;
        } else {
          const dadosFormatados = { ...this.salvarObjInfoFinanceira };
          dadosFormatados.RemuneracaoMensal = this.formatarValorFinanceiro(
            dadosFormatados.RemuneracaoMensal,
          );
          dadosFormatados.OutrosRendimentos = this.formatarValorFinanceiro(
            dadosFormatados.OutrosRendimentos,
          );
          dadosFormatados.BensImoveis = this.formatarValorFinanceiro(
            dadosFormatados.BensImoveis,
          );
          dadosFormatados.BensMoveis = this.formatarValorFinanceiro(
            dadosFormatados.BensMoveis,
          );
          dadosFormatados.PatrimonioLiquido = this.formatarValorFinanceiro(
            dadosFormatados.PatrimonioLiquido,
          );
          dadosFormatados.PatrimonioTotal = this.formatarValorFinanceiro(
            dadosFormatados.PatrimonioTotal,
          );
          await api
            .post("/PessoaFisica/dadosFinanceiros", dadosFormatados)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.commit("SET_PF_SALVAR_INFO_FINANCEIRAS", null);
                this.gravarDados.salvarInformacoesFinanceiras = 1;
                if (this.desabilitarNotificacao == false) {
                  this.$swal({
                    icon: "success",
                    title: "Cadastro!",
                    text: "Dados informados foram salvos com sucesso.",
                  });
                }
                return;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarInformacoesFinanceiras = 2;
              this.$store.commit("SET_PF_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos na aba Informações.",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    selectTab(tabSelected) {
      if (tabSelected <= this.maxTab || this.Edicao) {
        this.tab = tabSelected;
        this.menuAberto = false;
        if (tabSelected > this.maxTab) {
          this.maxTab = tabSelected;
        }
        this.$store.commit("SET_ETAPA_CADASTRO", this.tab);
      }
    },
    logoff() {
      this.$store.dispatch("auth/logout");
    },
    converterData(dataString) {
      if (dataString && dataString !== "0001-01-01T00:00:00") {
        let data = new Date(dataString);
        let ano = data.getFullYear();
        let mes = (data.getMonth() + 1).toString().padStart(2, "0");
        let dia = data.getDate().toString().padStart(2, "0");
        return `${ano}-${mes}-${dia}`;
      } else {
        return null;
      }
    },
    formatarDadosBasicos(dados) {
      return {
        DataNascimento: this.converterData(dados.DataNascimento),
        Sexo: dados.Sexo || "",
        EstadoCivil: dados.EstadoCivil || "",
        Ocupacao: dados.Ocupacao || "",
        NumeroDocumento: dados.NumeroDocumento || "",
        TipoDocumento: dados.TipoDocumento || "",
        DataEmissao: this.converterData(dados.DataEmissao),
        OrgaoEmissao: dados.OrgaoEmissao || "",
        DocumentoUf: dados.DocumentoUf || "",
        Nacionalidade: dados.Nacionalidade || "",
        PaisNascimento: dados.PaisNascimento || "",
        Naturalidade: dados.Naturalidade || "",
        Pais: dados.Pais || "",
        NomeMae: dados.NomeMae || "",
        NomePai: dados.NomePai || "",
        CidadeNascimento: dados.CidadeNascimento || "",
        NomeConjugue: dados.NomeConjugue || "",
        CpfConjugue: dados.CpfConjugue || "",
        Logradouro: dados.Logradouro || "",
        LogradouroNumero: dados.LogradouroNumero || "",
        LogradouroComplemento: dados.LogradouroComplemento || "",
        Bairro: dados.Bairro || "",
        Cidade: dados.Cidade || "",
        Cep: dados.Cep || "",
        Uf: dados.Uf || "",
        LogradouroPais: dados.LogradouroPais || "",
        Telefone: dados.Telefone || "",
        Telefone2: dados.Telefone2 || "",
        Email: dados.Email || "",
        PoliticamenteExposta: dados.PoliticamenteExposta,
        PoliticamenteExpostaDescricao:
          dados.PoliticamenteExpostaDescricao || "",
        FormacaoProfissional: dados.FormacaoProfissional || "",
        Instituicao: dados.Instituicao || "",
        CnpjTrabalha: dados.CnpjTrabalha || "",
        EnderecoComercial: dados.EnderecoComercial || "",
        EnderecoComercialNumero: dados.EnderecoComercialNumero || "",
        EnderecoComercialComplemento: dados.EnderecoComercialComplemento || "",
        EnderecoComercialBairro: dados.EnderecoComercialBairro || "",
        EnderecoComercialCep: dados.EnderecoComercialCep || "",
        EnderecoComercialCidade: dados.EnderecoComercialCidade || "",
        EnderecoComercialEstado: dados.EnderecoComercialEstado || "",
        EnderecoComercialPais: dados.EnderecoComercialPais || "",
        TelefoneComercial: dados.TelefoneComercial || "",
        EmailComercial: dados.EmailComercial || "",
        EnderecoCorrespondencia: dados.EnderecoCorrespondencia || "",
        LogradouroOutro: dados.LogradouroOutro || "",
        LogradouroNumeroOutro: dados.LogradouroNumeroOutro || "",
        LogradouroComplementoOutro: dados.LogradouroComplementoOutro || "",
        BairroOutro: dados.BairroOutro || "",
        CidadeOutro: dados.CidadeOutro || "",
        UfOutro: dados.UfOutro || "",
        CepOutro: dados.CepOutro || "",
        PaisOutro: dados.PaisOutro || "",
        ClienteIncapaz: dados.ClienteIncapaz,
        ClienteEmancipado: dados.ClienteEmancipado,
        NomeRepresentante: dados.NomeRepresentante || "",
        GrauRelacionamento: dados.GrauRelacionamento || "",
        EmissorOrdem: dados.EmissorOrdem,
        DocumentoRepresentante: dados.DocumentoRepresentante || "",
        CpfRepresentante: dados.CpfRepresentante || "",
        PepRepresentante: dados.PepRepresentante,
        NomeRepresentante2: dados.NomeRepresentante2 || "",
        GrauRelacionamento2: dados.GrauRelacionamento2 || "",
        EmissorOrdem2: dados.EmissorOrdem2,
        DocumentoRepresentante2: dados.DocumentoRepresentante2 || "",
        CpfRepresentante2: dados.CpfRepresentante2 || "",
        PepRepresentante2: dados.PepRepresentante2,
        SituacaoLegal: dados.SituacaoLegal,
        EmailRepresentante: dados.EmailRepresentante || "",
        EmailRepresentante2: dados.EmailRepresentante2 || "",
        AutoClassificacaoInvestidor: dados.AutoClassificacaoInvestidor || null,
      };
    },
    executaProximaEtapa() {
      this.tab = this.etapaCadastro;
      if (this.etapaCadastro > this.maxTab) {
        this.maxTab = this.etapaCadastro;
      }
    },
    async verificaSePassouPorTodosPassos() {
      this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);

      const etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 9];

      if (this.nomeEmpresa.toUpperCase() != "GENIAL") {
        etapasObrigatorias.push(4);
      }

      if (!Array.isArray(this.etapasConcluidas)) {
        return false;
      }

      const etapasConcluidas = Array.isArray(this.etapasConcluidas)
        ? this.etapasConcluidas.filter((e) => typeof e === "number")
        : [];

      const todasEtapasOk = etapasObrigatorias.every((etapa) =>
        etapasConcluidas.includes(etapa),
      );

      if (todasEtapasOk) {
        return true;
      } else {
        this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
        return false;
      }
    },
    async salvar() {
      this.salvarInformacoesFinanceiras();
      this.salvarInformacoesBancarias();
      this.salvarInformacoesDeclaracoes();
      this.salvarInformacoesUpload();
      this.salvarQuestionarioAsync();
      this.salvarInformacoesDispensaQuestionario();
      if (
        this.salvarObjInfoBasicas == null &&
        this.salvarObjInfoEndereco == null
      ) {
        this.gravarDados.salvarInformacoesPF = 1;
        return;
      } else {
        var objInfoBasicas = null;
        if (this.salvarObjInfoBasicas == null) {
          objInfoBasicas = this.formatarDadosBasicos(this.informacoesBasicas);
        } else {
          objInfoBasicas = this.salvarObjInfoBasicas;
        }
        if (this.salvarObjInfoEndereco != null) {
          objInfoBasicas.Cep = this.salvarObjInfoEndereco.Cep;
          objInfoBasicas.Logradouro = this.salvarObjInfoEndereco.Logradouro;
          objInfoBasicas.LogradouroNumero =
            this.salvarObjInfoEndereco.LogradouroNumero;
          objInfoBasicas.LogradouroComplemento =
            this.salvarObjInfoEndereco.LogradouroComplemento;
          objInfoBasicas.Bairro = this.salvarObjInfoEndereco.Bairro;
          objInfoBasicas.Cidade = this.salvarObjInfoEndereco.Cidade;
          objInfoBasicas.Uf = this.salvarObjInfoEndereco.Uf;
          objInfoBasicas.LogradouroPais =
            this.salvarObjInfoEndereco.LogradouroPais;
          objInfoBasicas.EnderecoCorrespondencia =
            this.salvarObjInfoEndereco.EnderecoCorrespondencia;
          objInfoBasicas.CepOutro = this.salvarObjInfoEndereco.CepOutro;
          objInfoBasicas.LogradouroOutro =
            this.salvarObjInfoEndereco.LogradouroOutro;
          objInfoBasicas.LogradouroNumeroOutro =
            this.salvarObjInfoEndereco.LogradouroNumeroOutro;
          objInfoBasicas.LogradouroComplementoOutro =
            this.salvarObjInfoEndereco.LogradouroComplementoOutro;
          objInfoBasicas.BairroOutro = this.salvarObjInfoEndereco.BairroOutro;
          objInfoBasicas.CidadeOutro = this.salvarObjInfoEndereco.CidadeOutro;
          objInfoBasicas.UfOutro = this.salvarObjInfoEndereco.UfOutro;
          objInfoBasicas.PaisOutro = this.salvarObjInfoEndereco.PaisOutro;
          objInfoBasicas.EnderecoComercialCep =
            this.salvarObjInfoEndereco.EnderecoComercialCep;
          objInfoBasicas.EnderecoComercial =
            this.salvarObjInfoEndereco.EnderecoComercial;
          objInfoBasicas.EnderecoComercialNumero =
            this.salvarObjInfoEndereco.EnderecoComercialNumero;
          objInfoBasicas.EnderecoComercialComplemento =
            this.salvarObjInfoEndereco.EnderecoComercialComplemento;
          objInfoBasicas.EnderecoComercialBairro =
            this.salvarObjInfoEndereco.EnderecoComercialBairro;
          objInfoBasicas.EnderecoComercialCidade =
            this.salvarObjInfoEndereco.EnderecoComercialCidade;
          objInfoBasicas.EnderecoComercialEstado =
            this.salvarObjInfoEndereco.EnderecoComercialEstado;
          objInfoBasicas.EnderecoComercialPais =
            this.salvarObjInfoEndereco.EnderecoComercialPais;
        }

        if (this.houveAlteracaoRepresentantesCriticos()) {
          var documentoAtivo = await verificarDocumentoAtivo();
          if (documentoAtivo) {
            var confirmado = await confirmarReassinatura();
            if (!confirmado) {
              this.gravarDados.salvarInformacoesPF = 2;
              this.$store.commit("SET_PF_SALVAR_INFO", false);
              return false;
            }
          }
        }

        await api
          .post("/PessoaFisica/informacaoBasica", objInfoBasicas)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.informacoesBasicas = {
                ...this.informacoesBasicas,
                ...objInfoBasicas,
              };
              this.$store.commit("SET_PF_SALVAR_INFO_BASICAS", null);
              this.$store.commit("SET_PF_SALVAR_INFO_ENDERECO", null);
              this.gravarDados.salvarInformacoesPF = 1;
              return;
            }
          })
          .catch((error) => {
            this.gravarDados.salvarInformacoesPF = 2;
            this.$store.commit("SET_PF_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Informações.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
  },
  watch: {
    salvouTodasAbas(newVal) {
      if (newVal) {
        this.salvarConcluir();
        if (this.solicitouProximaEtapa) {
          this.executaProximaEtapa();
          this.$store.commit("SET_PF_SALVAR_INFO", false);
        } else if (this.enviarCadastro) {
          this.salvarConcluir();
        }
        this.gravarDados.salvarInformacoesPF = 0;
        this.gravarDados.salvarInformacoesFinanceiras = 0;
        this.gravarDados.salvarInformacoesBancarias = 0;
        this.gravarDados.salvarInformacoesDeclaracoes = 0;
        this.gravarDados.salvarInformacoesUpload = 0;
        this.gravarDados.salvarQuestionario = 0;
        this.gravarDados.salvarInformacoesDispensaQuestionario = 0;
      }
    },
    enviarCadastro() {
      if (this.enviarCadastro) {
        this.$store.commit("SET_PF_SALVAR_INFO", true);
      }
    },
    etapaCadastro() {
      if (this.Edicao) {
        this.tab = this.etapaCadastro;
      } else if (this.etapaCadastro == 0) {
        this.executaProximaEtapa();
      } else {
        this.solicitouProximaEtapa = true;
      }
    },
    infoBasicas() {
      this.informacoesBasicas = this.infoBasicas;
      this.informacoesBasicas.Nome = this.user.NomeRazaoSocial;

      if (this.infoBasicas != null && this._repSnap == null) {
        this._repSnap = JSON.parse(JSON.stringify(this.infoBasicas));
      }
    },
    infoFinanceiras() {
      this.informacoesFinanceiras = this.infoFinanceiras;
    },
    infoBancarios() {
      this.informacoesBancarias = this.infoBancarios;
    },
    infoDeclaracoes() {
      this.informacoesDeclaracoes = this.infoDeclaracoes;
    },
    async salvarInformacoesPF() {
      if (this.salvarInformacoesPF) {
        if (this.BloquearSalvarIsolado) {
          this.$store.commit("SET_MODAL_QUESTIONARIO", false);
          this.$emit("update:Edicao", false);

          if (
            (await this.verificaSePassouPorTodosPassos()) == false ||
            !this.enviarCadastro
          ) {
            this.$store.commit("SET_PF_SALVAR_INFO", false);
            this.$store.commit("SET_ENVIAR_CADASTRO", false);
            return;
          }
          this.$store.commit("SET_ENVIAR_CADASTRO", false);
          this.$store.commit("SET_FICHA_CONCLUIR", true);
        } else if (
          this.Edicao &&
          !this.BloquearSalvarIsolado &&
          !this.enviarCadastro
        ) {
          this.$store.commit("SET_PF_SALVAR_INFO", false);
          this.$store.commit("SET_ENVIAR_CADASTRO", false);
          this.$store.commit("SET_MODAL_AVISO", "ModalConfirmar");
          this.$emit("update:Edicao", false);
          this.$store.commit("SET_FICHA_CONCLUIR", true);
          return;
        }

        await this.salvar();
      }
    },
  },
};
</script>

<style scoped>
/* Animações de transição para sidebar mobile */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
